import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { InsertEmojiCommandOptions } from 'vendor/ckeditor/plugins/emoji';
import { INSERT_EMOJI_COMMAND } from 'vendor/ckeditor/plugins/emoji/constants';

export const executeAddEmojiCommand = (
  emoji: string,
  editor: Editor | null,
): void => {
  if (editor == null) {
    return;
  }
  editor.execute<InsertEmojiCommandOptions>(INSERT_EMOJI_COMMAND, {
    emoji,
  });
  editor.editing.view.focus();
};
